import React from 'react'
import { Fragment } from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const Privacy = () => {
    return (
        <Fragment>

            <section className='pb-0'>
                <Container>
                    <div className="text-center">
                        <h2 className='font-medium text__48 mb-2'>Privacy Policy</h2>
                        <p className='text__16 text-[#525252]'>Effective Date: August 18, 2024</p>
                    </div>
                </Container>
            </section>

            <section>
                <Container>
                    <Row className='justify-center'>
                        <Col md={10}>
                            <h5 className='font-medium text__18 mb-3'>At Pantria, operated by Quenra Ltd, we are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, and protect your information when you use our food marketplace platform connecting home cooks with food lovers across the UK.</h5>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>1. Information We Collect</h5>
                                <p className='text__16 mb-2'><strong>Personal Information:</strong> Name, email address, phone number, delivery address, payment information, dietary preferences, and food safety certifications (for sellers).</p>
                                <p className='text__16 mb-2'><strong>Transaction Information:</strong> Order history, payment records, reviews, and ratings.</p>
                                <p className='text__16 mb-2'><strong>Food Safety Information:</strong> For sellers - food hygiene certificates, allergen information, preparation methods, and kitchen registration details.</p>
                                <p className='text__16'><strong>Technical Information:</strong> IP address, browser type, device information, and website usage data.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>2. How We Use Your Information</h5>
                                <p className='text__16 mb-2'>We process your personal data based on legitimate interests and contractual necessity to:</p>
                                <ul className='text__16 ml-4 mb-2'>
                                    <li>Facilitate food orders and deliveries</li>
                                    <li>Process payments and prevent fraud</li>
                                    <li>Ensure food safety compliance and traceability</li>
                                    <li>Verify seller credentials and food hygiene standards</li>
                                    <li>Communicate about orders, safety recalls, and platform updates</li>
                                    <li>Improve our platform and develop new features</li>
                                </ul>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>3. Information Sharing</h5>
                                <p className='text__16 mb-2'>We may share your information with:</p>
                                <ul className='text__16 ml-4 mb-2'>
                                    <li><strong>Home Cooks:</strong> Your name and delivery details for order fulfillment</li>
                                    <li><strong>Buyers:</strong> Seller ratings, food safety information, and allergen details</li>
                                    <li><strong>Payment Providers:</strong> Stripe, PayPal for secure payment processing</li>
                                    <li><strong>Delivery Partners:</strong> Name and address for food delivery</li>
                                    <li><strong>Food Safety Authorities:</strong> When required for health and safety compliance</li>
                                    <li><strong>Legal Authorities:</strong> When required by law or to protect safety</li>
                                </ul>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>4. Your Rights (GDPR)</h5>
                                <p className='text__16 mb-2'>Under UK GDPR, you have the right to:</p>
                                <ul className='text__16 ml-4 mb-2'>
                                    <li>Access your personal data</li>
                                    <li>Correct inaccurate information</li>
                                    <li>Delete your personal data (with exceptions for food safety records)</li>
                                    <li>Restrict processing of your data</li>
                                    <li>Data portability</li>
                                    <li>Object to processing</li>
                                    <li>Withdraw consent at any time</li>
                                </ul>
                                <p className='text__16'>To exercise these rights, contact us at hello@pantria.co</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>5. Data Retention</h5>
                                <p className='text__16 mb-2'>We retain personal data for:</p>
                                <ul className='text__16 ml-4 mb-2'>
                                    <li><strong>Transaction records:</strong> 7 years (UK accounting requirements)</li>
                                    <li><strong>Food safety records:</strong> 2 years (food traceability requirements)</li>
                                    <li><strong>Account information:</strong> Until account deletion (subject to legal requirements)</li>
                                    <li><strong>Marketing data:</strong> Until consent is withdrawn</li>
                                </ul>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>6. Food Safety & Health</h5>
                                <p className='text__16'>We maintain detailed records of food preparation, allergen information, and seller certifications to ensure consumer safety and enable rapid response to food safety incidents. This information may be retained longer than other personal data to comply with UK food safety regulations.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>7. Security</h5>
                                <p className='text__16'>We use industry-standard security measures including encryption, secure servers, and regular security audits to protect your personal information. However, no online transmission is 100% secure.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>8. Children's Privacy</h5>
                                <p className='text__16'>Our platform is not intended for children under 16. We do not knowingly collect personal information from children under 16 without parental consent.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>9. Changes to This Policy</h5>
                                <p className='text__16'>We may update this Privacy Policy to reflect changes in our practices or legal requirements. We will notify users of significant changes via email or platform notification.</p>
                            </div>

                            <div className="mb-4">
                                <h5 className='font-medium text__18 mb-2'>10. Contact & Complaints</h5>
                                <p className='text__16 mb-2'><strong>Data Controller:</strong> Quenra Ltd</p>
                                <p className='text__16 mb-2'><strong>Email:</strong> hello@pantria.co</p>
                                <p className='text__16'>If you're not satisfied with our response, you can lodge a complaint with the Information Commissioner's Office (ICO) at ico.org.uk</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </Fragment>
    )
}

export default Privacy